import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { Ng2PaginationModule } from 'ng2-pagination';
import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { CKEditorModule } from 'ng2-ckeditor';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MainComponent } from './main/main.component';
import { DashboardOnlineComponent } from 'app/dashboard-online/dashboard-online.component';

import { appRoutes, appRoutingProviders } from './app.routes';
import { ToastOption } from "./toast-option";
import { ProfileService } from './profile.service';
import { HeaderService } from "./header.service";
import { ProgressComponent } from './progress/progress.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { RedemptionComponent } from './redemption/redemption.component';
import { IssuanceComponent } from "./issuance/issuance.component";
import { PenjatahanIssuanceComponent } from "./penjatahan/issuance/penjatahanissuance.component";
import { RedemptionDetailComponent } from './redemption/redemption-detail/redemption-detail.component';
import { IssuanceDetailComponent } from './issuance/issuance-detail/issuance-detail.component';
import { PenjatahanIssuanceDetailComponent } from './penjatahan/issuance/penjatahanissuance-detail/penjatahanissuance-detail.component';
import { AuctionComponent } from './auction/auction.component';
import { AuctionDetailComponent } from './auction/auction-detail/auction-detail.component';
import { SeriesComponent } from './auction/series/series.component';
import { SeriesSaComponent } from './auction/series-sa/series-sa.component';
import { SubagentComponent } from './auction/subagent/subagent.component';
import { ReportComponent } from './auction/report/report.component';
import { AlertComponent } from './alert/alert.component';
import { RedemptionConfirmComponent } from './redemption-confirm/redemption-confirm.component';
import { UserComponent } from './user/user.component';
import { GroupComponent } from './group/group.component';
import { AgentComponent } from './agent/agent.component';
import { InvestorComponent } from './investor/investor.component';
import { InvestorDetailComponent } from './investor/investor-detail/investor-detail.component';
import { UploadIssuanceComponent } from 'app/upload-issuance/upload-issuance.component';
import { UploadIssuanceHasilComponent } from 'app/upload-issuance/upload-issuance-hasil/upload-issuance-hasil.component';
import { UploadIssuanceService } from 'app/upload-issuance/upload-issuance.service';
import { UploadCheckerComponent } from 'app/upload-checker/upload-checker.component';
import { UploadCheckerHasilComponent } from 'app/upload-checker/upload-checker-hasil/upload-checker-hasil.component';
import { FileUtil } from './upload-issuance/file.util';
import { Constants } from './upload-issuance/test.constants';
import { FileUtilC } from './upload-checker/file.util';
import { ConstantsC } from './upload-checker/test.constants';
import { CustomRedemptionComponent } from './ritel-online/custom-redemption/custom-redemption.component';
import { CustomPemesananComponent } from './ritel-online/custom-pemesanan/custom-pemesanan.component';
import { RitelOnlineComponent } from './ritel-online/ritel-online.component';
// import { CustomDetailComponent } from './ritel-online/custom-pemesanan/custom-detail/custom-detail.component';
import { CustompemesananDetailComponent } from './ritel-online/custom-pemesanan/custompemesanan-detail/custompemesanan-detail.component';
import { CustomredemptionDetailComponent } from './ritel-online/custom-redemption/customredemption-detail/customredemption-detail.component';
import { PaginationComponent } from "./pagination/pagination.component";
import { SimpleTimer } from 'ng2-simple-timer';
import { DownloadComponent } from './download/download.component';
import { PejabatService } from './pejabat.service';
import { ExcelService } from './excel.service';
import { DownloadDailyReportComponent } from './downloaddailyreport/downloaddailyreport.component';
import { EmailComponent } from './email/email.component';
import { EmailDetailComponent } from './email/email-detail/email-detail.component';
import { PushNtpnComponent } from 'app/push-ntpn/push-ntpn.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    SidebarComponent,
    DashboardComponent,
    DashboardOnlineComponent,
    MainComponent,
    ProgressComponent,
    UserProfileComponent,
    RedemptionComponent,
    IssuanceComponent,
    PenjatahanIssuanceComponent,
    RedemptionDetailComponent,
    IssuanceDetailComponent,
    PenjatahanIssuanceDetailComponent,
    AuctionComponent,
    AuctionDetailComponent,
    SeriesComponent,
    SeriesSaComponent,
    SubagentComponent,
    ReportComponent,
    AlertComponent,
    RedemptionConfirmComponent,
    UserComponent,
    GroupComponent,
    AgentComponent,
    InvestorComponent,
    InvestorDetailComponent,
    UploadIssuanceComponent,
    UploadIssuanceHasilComponent,
    UploadCheckerComponent,
    UploadCheckerHasilComponent,
    CustomRedemptionComponent ,
    CustomPemesananComponent,
    RitelOnlineComponent,
    // CustomDetailComponent,
    CustompemesananDetailComponent,
    CustomredemptionDetailComponent,
    PaginationComponent,
    DownloadComponent,
    DownloadDailyReportComponent,
    EmailComponent,
    EmailDetailComponent,
    PushNtpnComponent
  ],
  imports: [
 
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    appRoutes,
    Ng2AutoCompleteModule,
    Ng2PaginationModule,
    ToastModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    NKDatetimeModule,
    Ng2OrderModule,
    JsonpModule,
    CKEditorModule,
    ReactiveFormsModule
  ],
  exports: [
    PaginationComponent
  ],
  providers: [{ provide: ToastOptions, useClass: ToastOption }, ProfileService, HeaderService, FileUtil, Constants, UploadIssuanceService, PejabatService, FileUtilC, ConstantsC, SimpleTimer, ExcelService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/app.module.ts